export default __webpack_public_path__ + "static/media/OrganizationalContact.7a420aba.svg";